
























import Vue from "vue"
import SectionTitle from "~/components/guideline/util/SectionTitle.vue"
import RowGroup from "~/components/guideline/util/RowGroup.vue"
import ColumnWithIcon from "~/components/guideline/util/ColumnWithIcon.vue"
import { DESCRIPTION_ICON } from "~/config/icon"
import EditItemDescription from "~/components/guideline/util/EditItemDescription.vue"

export default Vue.extend({
  components: {
    SectionTitle,
    RowGroup,
    ColumnWithIcon,
    EditItemDescription,
  },
  props: {
    supplementaryExplanation: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icon: {
        description: DESCRIPTION_ICON,
      },
    }
  },
  computed: {
    editLinkForSectionTitle(): string {
      if (!this.isEditable) {
        return ""
      }
      return "/profiles/edit/supplementary_explanation"
    },
  },
})
